import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import { textContentPropType } from "../../lib/dataShapes";
import styles from "../../styles/columns.module.scss";
import ColumnImage from "./ColumnImage";
import TextContent from "./TextContent";

const Columns = ({ columns }) => {
  const [headers, contents] = columns.reduce(
    ([headers, contents], col) => [
      [...headers, col.header],
      [...contents, { content: col.content, illustration: col.illustration }]
    ],
    [[], []]
  );
  return (
    <div className={styles.columnsContainer}>
      <div className={styles.columns}>
        {headers.map((header, index) => (
          <div key={index} className={styles.column}>
            <h2>{header}</h2>
          </div>
        ))}
      </div>
      <div className={styles.columns}>
        {contents.map((content, index) => (
          <div key={index} className={styles.column}>
            <div className={styles.columnContent}>
              <TextContent content={content.content} />
              {!_.isEmpty(content.illustration) && (
                <ColumnImage illustration={content.illustration} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

Columns.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      content: textContentPropType,
      illustration: PropTypes.shape({
        illustration: PropTypes.string,
        customSrc: PropTypes.string
      })
    })
  ).isRequired
};

export default Columns;

//
